export default function http_env() {
  const host = window.location.host;

  if(host.indexOf('dev') != -1 || host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    return 'dev';
  }
  if(host.indexOf('test') != -1){
    return 'test';
  }
  if(host.indexOf('staging') != -1){
    return 'staging';
  }
  return '';
}


// WEBPACK FOOTER //
// ./src/utils/http_env.js